import { Card, pn, Stack, ValidationErrors } from "@compass/core";
import {
  StudentFilter as StudentFilterModel,
  StudentReportServiceSummaryRequest,
  StudentReportServiceSummaryResource,
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { ServiceSummaryDisplay } from "./ServiceSummaryDisplay";
import { StudentServiceFilter } from "pages/students/student-services/StudentServiceFilter";
import { StudentFilter } from "pages/students/students/StudentFilter";

export const ServiceSummaryRequest = (props: {
  initialized: boolean;
  request: StudentReportServiceSummaryRequest;
  setRequest: (value: StudentReportServiceSummaryRequest) => void;
  globalCommonFilter: StudentFilterModel;
  setGlobalCommonFilter: (value: StudentFilterModel) => void;
  validationErrors: ValidationErrors;
}) => {
  const [resource, setResource] = useState<StudentReportServiceSummaryResource>({});

  useEffect(() => {
    if (props.initialized) {
      ApiService.studentReports.getServiceSummaryRequest().then((response) => {
        props.setRequest(response);
      });

      ApiService.studentReports.getServiceSummaryResource().then((response) => {
        setResource(response);
      });
    }
  }, [props.initialized]);

  return (
    <Stack spacing="lg">
      <Card header="Common Filter">
        <StudentFilter
          filter={props.globalCommonFilter || ({} as StudentFilterModel)}
          setFilter={props.setGlobalCommonFilter}
        />
      </Card>

      <Card header="Service Filter">
        <StudentServiceFilter
          filter={props.request.studentServiceFilter || {}}
          setFilter={(filter) =>
            props.setRequest(
              produce(props.request, (draft) => {
                draft.studentServiceFilter = filter;
              })
            )
          }
        />
      </Card>

      <ServiceSummaryDisplay
        display={props.request.display || {}}
        setDisplay={(display) =>
          props.setRequest(
            produce(props.request, (draft) => {
              draft.display = display;
            })
          )
        }
        resource={resource.display || {}}
        validationErrors={props.validationErrors[pn<StudentReportServiceSummaryRequest>("display")] || {}}
      />
    </Stack>
  );
};
